import {
  SecondaryButton as EtSecondaryButton,
  ButtonTheme,
  Size,
} from "@ever-tutor/et-ui";
import { useId, type ComponentProps } from "react";

const SecondaryButton = ({
  children,
  onClick,
  size = "md",
  theme = ButtonTheme.LIGHT,
  disabled = false,
  mobileFullWidth = false,
  className = "",
  id: providedId,
  "aria-label": label,
  "aria-labelledby": labelledBy,
  ...buttonProps
}: {
  children: React.ReactNode;
  onClick: () => void;
  size?: Size | "sm" | "md" | "lg";
  theme?: ButtonTheme;
  disabled?: boolean;
  mobileFullWidth?: boolean;
  className?: string;
} & Omit<ComponentProps<typeof EtSecondaryButton>, "size">) => {
  const generatedId = useId();
  const id = providedId || generatedId;
  const accessibility =
    label !== undefined
      ? { "aria-label": label }
      : { "aria-labelledby": labelledBy || id };
  const sizeMap: Record<string, Size> = {
    sm: Size.SM,
    md: Size.MD,
    lg: Size.LG,
  };

  const finalSize = typeof size === "string" ? sizeMap[size] : size;

  return (
    <EtSecondaryButton
      onClick={onClick}
      size={finalSize || Size.MD}
      theme={theme}
      disabled={disabled}
      mobileFullWidth={mobileFullWidth}
      className={`et-secondary ${className}`}
      id={id}
      {...accessibility}
      {...buttonProps}
    >
      {children}
    </EtSecondaryButton>
  );
};

export default SecondaryButton;
